module.exports = __webpack_public_path__ + "static/media/thList.8108e984.svg";